import type { CustomFont } from "./layout";
const validMedia = (s: string) => /^\/media\/[a-f0-9-]+$/.test(s);
const loadedFonts = new Map<string, Promise<FontFace>>();
export function installFonts(theme: any, origin: string) {
  if (typeof FontFace === "undefined") return;
  const pending: Promise<FontFace>[] = [];
  for (const f of (theme.fonts ?? []) as CustomFont[]) {
    if (!/^[a-zA-Z0-9-]{1,64}$/.test(f.id) || !validMedia(f.url)) continue;
    const url = new URL(f.url, origin).href;
    if (!loadedFonts.has(url)) {
      const face = new FontFace(`pd-${f.id}`, `url("${url}")`);
      const promise = face.load().then((font) => {
        document.fonts.add(font);
        return font;
      });
      loadedFonts.set(url, promise);
      void promise.catch(() => loadedFonts.delete(url));
    }
    pending.push(loadedFonts.get(url)!);
  }
  return Promise.allSettled(pending);
}
